<template>
  <div class="pass-upgrade">
    <div class="pass-upgrade__indicator">
      <p class="pass-upgrade__copy pass-upgrade__pass">
        You are currently on<br />
        the <span class="pass-upgrade__pass--name">Starter Pass</span>
      </p>
    </div>
    <div class="pass-upgrade__button-wrapper">
      <a href="//ine.com/pages/plans" class="pass-upgrade__button">
        Upgrade Pass
        <UpgradeIcon class="pass-upgrade__button--icon" />
      </a>
    </div>
  </div>
</template>

<script>
import UpgradeIcon from '@/assets/icons/navigation/upgrade_pass.svg'

export default {
  name: 'PassUpgrade',
  components: {
    UpgradeIcon: { ...UpgradeIcon, name: 'UpgradeIcon' },
  },
}
</script>

<style lang="scss" scoped>
.pass-upgrade {
  margin: 0 5px 0 0;
  display: flex;
  align-items: center;
  @include desktop {
    margin: 0 25px 0 0;
  }
  &__indicator {
    margin: 0 25px 0 0;
  }
  &__copy {
    color: var(--white);
    margin: 0;
    padding: 0;
    @include desktop {
      white-space: nowrap;
    }
  }
  &__pass {
    margin: 0;
    @include desktop {
      margin: 0 0 0 27px;
    }
    &--name {
      text-decoration: underline;
    }
  }
  &__button {
    background: transparent;
    border: 2px solid var(--white);
    padding: 7px 15px;
    color: var(--white);
    border-radius: 25px;
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: 0.3s all ease;
    text-transform: uppercase;
    font-size: rem(12px);
    font-family: var(--font-bold);
    white-space: nowrap;
    @include desktop {
      font-size: rem(14px);
    }
    &:hover {
      color: var(--black);
      background: var(--white);
      .pass-upgrade__button--icon {
        fill: var(--black);
      }
    }
    &--icon {
      transition: 0.3s all ease;
      fill: var(--white);
      margin: 0 0 0 15px;
      width: 24px;
      display: none;
      @include desktop {
        display: block;
      }
    }
  }
}
</style>
